import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependecy'
import { getBootstrapIconUrlByKey } from '../Global/icons'
import { TemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
    <!-- Utility Button -->
    <wa-button
        id="btnUtility"
        size="small"
        class="utility-btn">
        <slot name="start"></slot>
        <slot name="buttonText"></slot>
        <slot name="end"></slot>
    </wa-button>
`
class NavHeaderUtilityButton extends HTMLElement {
  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Button])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderUtilityButton connectedCallback', this)

    const shadow = this.shadowRoot
    if (shadow) {
      const btn = shadow.querySelector('wa-button')
      if (btn) {
        // Handle dynamic icon creation
        const iconName = this.getAttribute('icon') // e.g., "person-circle", "bell", "gear"

        if (iconName) {
          tryLoadDependencies(document, [WebAwesomeComponent.Icon])

          try {
            // Get the icon URL dynamically using the new centralized method
            const svgUrl = getBootstrapIconUrlByKey(iconName)

            // Get icon position (default to 'start')
            const iconPosition = this.getAttribute('icon-position') || 'start'

            // Create a new icon element
            const iconEl = document.createElement('wa-icon')
            iconEl.setAttribute('slot', iconPosition)
            iconEl.setAttribute('src', svgUrl)
            iconEl.classList.add('utility-icon')

            btn.appendChild(iconEl)
          } catch (error) {
            console.warn(`Icon '${iconName}' not found in BootstrapIcon enum`, error)
          }
        }

        // Pass through wa-button attributes
        const attributes = ['size', 'variant', 'appearance', 'with-caret', 'disabled', 'type']
        attributes.forEach((attr) => {
          const value = this.getAttribute(attr)
          if (value !== null) {
            btn.setAttribute(attr, value)
          }
        })

        // Pass through aria attributes
        const ariaAttrs = ['aria-label', 'aria-expanded', 'aria-haspopup', 'aria-controls']
        ariaAttrs.forEach((attr) => {
          const value = this.getAttribute(attr)
          if (value) {
            btn.setAttribute(attr, value)
          }
        })
      }
    }
  }
}

if (!customElements.get('ts-navheader-utility-button')) {
  customElements.define('ts-navheader-utility-button', NavHeaderUtilityButton)
}
export { NavHeaderUtilityButton }
